module.exports = __webpack_public_path__ + "img/IMG_8512_FoamcoreMatted.e4a6e562.jpg";